export default __webpack_public_path__ + "static/media/open_library.d4508447.png";